import { Injectable, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '../base/base.component';

@Injectable()
export abstract class ModalComponent extends BaseComponent {
  /**
   * Reference to the actual template. This uses 'template' as template name.
   */
  @ViewChild('template')
  public abstract template: TemplateRef<any>;

  /**
   * Reference (ModalRef) to the actual modal.
   */
  public abstract modalRef: NgbModalRef;

  constructor(protected modalService: NgbModal, private readonly options?: NgbModalOptions) {
    super();
  }

  /**
   * This function calls, when the modal starts opening.
   */
  public openModal() {
    if (this.beforeOpen) {
      this.beforeOpen();
    }
    this.modalRef = this.modalService.open(this.template, this.options);
  }

  /**
   * This function calls, when the modal starts closing.
   */
  public closeModal() {
    if (this.beforeClose) {
      this.beforeClose();
    }
    this.modalRef.close();
  }
}

export interface ModalComponent {
  /**
   * This function starts during the modal is closing.
   */
  beforeClose?(): void;

  /**
   * This function starts during the modal is opening.
   */
  beforeOpen?(): void;
}
